import { render, staticRenderFns } from "./IntegrationForm.vue?vue&type=template&id=0f2b1a6a&scoped=true&"
import script from "./IntegrationForm.vue?vue&type=script&lang=ts&"
export * from "./IntegrationForm.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationForm.vue?vue&type=style&index=0&id=0f2b1a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2b1a6a",
  null
  
)

export default component.exports